const LISTAR_DADOS = (state, payload) => {
    state.items = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const LISTAR_DADOS_PAGINADOS = (state, payload) => {
    state.itemsPaginados = payload
}

export {
    LISTAR_DADOS,
    CARREGANDO,
    LISTAR_DADOS_PAGINADOS
}
